/*eslint-disable */
import React, { Component } from "react";
import {
  Grid,
  Segment,
  Placeholder,
  Label,
  Icon,
  Pagination,
  Dropdown,
} from "semantic-ui-react";
import cogoToast from "cogo-toast";
import { Link } from "react-router-dom";
import GridPlaceholder from "./gridPlaceholder";
import RouteManager from "./routeManager";
import ReadAxios from "../axiosComponent/read";
import CreatAxios from "../axiosComponent/create";
import MiniPlaceholder from "./miniPlaceHolder";
import VehicleType from "./vehicleType";
import { translate } from "react-i18next";
import LoadTyperender from "../dynamicComponent/loadTypeDisplay";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import moment from "moment";
import BLNumbers from "./getblno";
import OrdersHeader from "../orderComponent/ordersHeaders";
import ExportPDF from "../../components/axiosComponent/exportPDF";
import ReadAxiosRequestAxios from "../axiosComponent/allAxiosCommonRequest";
import { FEATURES, DATE_FORMATS } from "../../utils/constant";

export class shipmentGridView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      responseReceived: false,
      searchLoading:false,
      spinnerLoading: false,
      listItems: [],
      currentPage: 1,
      itemCount: 10,
      itemsPerPage: 10,
      setPageValue: 10,
      status: "",
      moment_type:
        Number(localStorage.getItem("customerNumber")) == 1122
          ? "import"
          : "primary",
      payload: {},
      totalItems: 1,
      totalPages: null,
      isFetching: false,
      showFilterDiv: false,
      page: 0,
      exportDataFromSearch: null,
      searchValue: "",
      filterState: false,
      loadingPagination: false,
    };
  }

  componentDidMount() {
    this.getOrderMetaData();
    // window scroll listener attached
    let billingpartbranchIds = localStorage.getItem("billingpartbranchIds")
      ? localStorage.getItem("billingpartbranchIds")
      : "";
    let billingpartIds = localStorage.getItem("billingpartIds")
      ? localStorage.getItem("billingpartIds")
      : "";
    let branchIds = localStorage.getItem("branchIds")
      ? localStorage.getItem("branchIds")
      : "";
    let tempbillingpartbranchIds =
      billingpartbranchIds != "" ? billingpartbranchIds.split(",") : [];
    let tempbillingpartIds =
      billingpartIds != "" ? billingpartIds.split(",") : [];
    let tempbranchIds = branchIds != "" ? branchIds.split(",") : [];
    let payload = {
      booking_branch_ids: tempbranchIds,
      billing_party_ids: tempbillingpartIds,
      billing_party_branch_ids: tempbillingpartbranchIds,
    };
    this.setState({
      isFetching: true,
      payload: payload,
    });
    let data = this.state.exportDataFromSearch;

    if (!data) {
      data = {
        bl_no: "",
        vendor_id: "",
        vehicle_no: "",
        order_reference_no: "",
        delivery_reference_no: "",
        required_on: "",
        end_required_on: "",
        invoice_no: "",
        common_order_number: "",
      };
    }

    if (Number(localStorage.getItem("customerNumber")) == 1122) {
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&total_items=${this.state.totalItems}&limit=${this.state.setPageValue}`,
        payload,
      })
        .then((res) => {
          this.setState({
            isFetching: false,
            listItems: res.data.data,
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&total_items=${this.state.totalItems}&page=1&limit=${this.state.setPageValue}`,
        payload,
      })
        .then((res) => {
          this.setState({
            isFetching: false,
            listItems: res.data.data,
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
    // this.fetchData();
  }

  componentDidUpdate(prevProps) { }

  getOrderMetaData = () => {
    let billingpartbranchIds = localStorage.getItem("billingpartbranchIds");
    let billingpartIds = localStorage.getItem("billingpartIds");
    let branchIds = localStorage.getItem("branchIds");
    let tempbillingpartbranchIds =
      billingpartbranchIds != "" && billingpartbranchIds?.length > 0
        ? billingpartbranchIds.split(",")
        : [];
    let tempbillingpartIds =
      billingpartIds != "" && billingpartIds?.length > 0
        ? billingpartIds.split(",")
        : [];
    let tempbranchIds =
      branchIds != "" && branchIds?.length > 0 ? branchIds.split(",") : [];
    let payload = {
      booking_branch_ids: tempbranchIds,
      billing_party_ids: tempbillingpartIds,
      billing_party_branch_ids: tempbillingpartbranchIds,
    };

    // this.setState({ loadingPagination: true });
    CreatAxios({
      completeURL: `${process.env.REACT_APP_BASE_URL}/transporter-allocation/orders/count?limit=10&total_items=1&page=1&movement_type=${this.state.moment_type}`,
      payload,
    })
      .then((res) => {
        this.setState({
          // loadingPagination: false,
          // isFetching: false,
          currentPage: res.data.data.currentPage,
          itemCount: res.data.data.itemCount,
          itemsPerPage: res.data.data.itemsPerPage,
          totalItems: res.data.data.totalItems,
          totalPages: res.data.data.totalPages,
        });
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({
          // loadingPagination: false,
          // isFetching: false,
          currentPage: 1,
          itemCount: 10,
          itemsPerPage: 10,
          totalItems: null,
          totalPages: null,
        });
      });
  };

  getOrderListing = (limit) => {
    this.getOrderMetaData();
    let billingpartbranchIds = localStorage.getItem("billingpartbranchIds");
    let billingpartIds = localStorage.getItem("billingpartIds");
    let branchIds = localStorage.getItem("branchIds");
    let tempbillingpartbranchIds =
      billingpartbranchIds != "" ? billingpartbranchIds.split(",") : [];
    let tempbillingpartIds =
      billingpartIds != "" ? billingpartIds.split(",") : [];
    let tempbranchIds = branchIds != "" ? branchIds.split(",") : [];
    let payload = {
      booking_branch_ids: tempbranchIds,
      billing_party_ids: tempbillingpartIds,
      billing_party_branch_ids: tempbillingpartbranchIds,
    };
    this.setState({
      isFetching: true,
      payload: payload,
      itemsPerPage: limit,
    });
    if (this.state.moment_type != 0) {
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&limit=${limit}&total_items=${this.state.totalItems}&status=${this.state.status}&movement_type=${this.state.moment_type}`,
        payload,
      })
        .then((res) => {
          console.log("new", res.data);
          this.setState({
            isFetching: false,
            listItems: res.data.data,
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&limit=${limit}&total_items=${this.state.totalItems}&status=${this.state.status}`,
        payload,
      })
        .then((res) => {
          console.log("new", res.data);
          this.setState({
            isFetching: false,
            listItems: res.data.data,
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  handlePagination = (e, data) => {
    // console.log(data.value)
    this.setState({ setPageValue: data.value });
    this.getOrderListing(data.value);
  };

  handleFilterPadding = (filterStateRecieved) => {
    this.setState({ filterState: filterStateRecieved });
  };

  handleFilter = () => {
    this.setState({ showFilterDiv: !this.state.showFilterDiv });
  };

  externalAPIexcelDownload = (data) => {
    this.setState({ spinnerLoading: true });
    let payload = {
      bl_no: this.state?.exportDataFromSearch?.bl_no
        ? this.state.exportDataFromSearch.bl_no
        : "",
      vendor_id: this.state?.exportDataFromSearch?.vendor_id
        ? this.state.exportDataFromSearch.vendor_name
        : "",
      vehicle_no: this.state?.exportDataFromSearch?.vehicle_no
        ? this.state.exportDataFromSearch.vehicle_no
        : "",
      order_reference_no: this.state?.exportDataFromSearch?.order_reference_no
        ? this.state.exportDataFromSearch.order_reference_no
        : "",
      delivery_reference_no: this.state?.exportDataFromSearch
        ?.delivery_reference_no
        ? this.state.exportDataFromSearch.delivery_reference_no
        : "",
      required_on: this.state?.exportDataFromSearch?.required_on
        ? this.state.exportDataFromSearch.required_on
        : "",
      end_required_on: this.state?.exportDataFromSearch?.end_required_on
        ? this.state.exportDataFromSearch.end_required_on
        : "",
      invoice_no: this.state?.exportDataFromSearch?.invoice_no
        ? this.state.exportDataFromSearch.invoice_no
        : "",
      common_order_number: this.state?.exportDataFromSearch?.common_order_number
        ? this.state.exportDataFromSearch.common_order_number
        : "",

      status: this.state?.exportDataFromSearch?.status
        ? this.state.exportDataFromSearch.status
        : "",

      transporter_lr_no: this.state?.exportDataFromSearch?.transporter_lr_no
        ? this.state.exportDataFromSearch.transporter_lr_no
        : "",
      route_id: this.state?.exportDataFromSearch?.route_id
        ? this.state.exportDataFromSearch.route_id
        : "",
      consignor_id: this.state?.exportDataFromSearch?.consignor_id
        ? this.state.exportDataFromSearch.consignor_id
        : "",
      consignee_id: this.state?.exportDataFromSearch?.consignee_id
        ? this.state.exportDataFromSearch.consignee_id
        : "",
      from_order_created_on: this.state?.exportDataFromSearch?.from_order_created_on
        ? this.state.exportDataFromSearch.from_order_created_on
        : "",
      to_order_created_on: this.state?.exportDataFromSearch?.to_order_created_on
        ? this.state.exportDataFromSearch.to_order_created_on
        : "",
      lr_no: this.state?.exportDataFromSearch?.lr_no
        ? this.state.exportDataFromSearch.lr_no
        : "",
      product_id: this.state?.exportDataFromSearch?.product_id
        ? this.state.exportDataFromSearch.product_id
        : "",
      product_category_id: this.state?.exportDataFromSearch?.product_category_id
        ? this.state.exportDataFromSearch.product_category_id
        : "",
    };
    let billingPartyBranchIds =
      localStorage.getItem("billingpartbranchIds").length > 0
        ? JSON.stringify(
          localStorage.getItem("billingpartbranchIds").toString()
        )
        : "";
    let bookingBranchIds =
      localStorage.getItem("branchIds").length > 0
        ? JSON.stringify(localStorage.getItem("branchIds").toString())
        : "";

    if (data === "full") {
      ReadAxiosRequestAxios({
        url: `${process.env.REACT_APP_TA_API_URL}/orders/excel/export?movement_type=${this.state.moment_type}&bl_no=${payload.bl_no}&status=${payload.status}&vendor_name=${payload.vendor_name}&transporter_lr_no=${payload.transporter_lr_no}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&booking_branch_ids=${bookingBranchIds}&billing_party_branch_ids=${billingPartyBranchIds}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&product_id=${payload.product_id}&product_category_id=${payload.product_category_id}&lr_no=${payload.lr_no}&export_type=${data}&`,
        method: "get",
        noQ: true,
      })
        .then((res) => {
          cogoToast.success(res.data.message);
          if (res?.status == 200) {
            this.setState({ responseReceived: true });
          }
          this.setState({ spinnerLoading: false });
        })
        .catch((err) => {
          if (err?.response?.data?.message)
            cogoToast.error(err.response.data.message);
          else cogoToast.error("Error While Demapping invoice.");
          this.setState({ spinnerLoading: false });
          console.log("err", err);
        });
    }
  };

  handlePaginationChange = (e, { activePage }) => {
    let payload = this.state.payload;
    this.setState({
      isFetching: true,
      currentPage: activePage,
      listItems: [],
    });
    let data = this.state.exportDataFromSearch;
    if (!data) {
      data = {
        bl_no: "",
        vendor_id: "",
        vehicle_no: "",
        order_reference_no: "",
        delivery_reference_no: "",
        required_on: "",
        end_required_on: "",
        invoice_no: "",
        common_order_number: "",
        route_id: "",
        consignor_id: "",
        consignee_id: "",
        from_order_created_on:"",
        to_order_created_on:"",
        lr_no:"",
        product_id : "",
        product_category_id : ""
      };
    }
    if (this.state.moment_type != 0) {
      //CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=${activePage}&limit=${this.state.itemsPerPage}&status=${this.state.status}&movement_type=${this.state.moment_type}`, payload })
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${data?.status ? data.status : this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&route_id=${data.route_id}&consignor_id=${data.consignor_id}&consignee_id=${data.consignee_id}&page=${activePage}&limit=${this.state.itemsPerPage}&total_items=${this.state.totalItems}&from_order_created_on=${data.from_order_created_on}&to_order_created_on=${data.to_order_created_on}&lr_no=${data.lr_no}&product_id=${data.product_id}&product_category_id=${data.product_category_id}`,
        payload,
      })
        .then((res) => {
          this.setState({
            isFetching: false,
            listItems: res.data.data,
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      //CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=${this.state.currentPage}&limit=${this.state.itemsPerPage}&status=${this.state.status}`, payload })

      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?status=${data?.status ? data.status : this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&route_id=${data.route_id}&consignor_id=${data.consignor_id}&consignee_id=${data.consignee_id}&page=${activePage}&limit=${this.state.itemsPerPage}&total_items=${this.state.totalItems}&from_order_created_on=${data.from_order_created_on}&to_order_created_on=${data.to_order_created_on}&lr_no=${data.lr_no}&product_id=${data.product_id}&product_category_id=${data.product_category_id}`,
        payload,
      })
        .then((res) => {
          console.log("new", res.data);
          this.setState({
            isFetching: false,
            listItems: res.data.data,
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  handleFilterChange = (data) => {
    this.setState(
      {
        isFetching: true,
        moment_type: data,
        currentPage: 1,
      },
      () => {
        this.getOrderMetaData();

        const payload = this.state.payload;
        if (data.length != 0) {
          if (this.state.status.length != 0) {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${data}&status=${data?.status ? data.status : this.state.status}&page=1&limit=${this.state.itemsPerPage}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            console.log("status not here");
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${data}&page=1&limit=${this.state.itemsPerPage}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          }
        } else {
          if (this.state.status.length != 0) {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?status=${this.state.status}&page=1&limit=${this.state.itemsPerPage}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                  itemCount: res.data.meta.itemCount,
                  itemsPerPage: res.data.meta.itemsPerPage,
                  totalItems: res.data.meta.totalItems,
                  totalPages: res.data.meta.totalPages,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&limit=${this.state.itemsPerPage}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                  itemCount: res.data.meta.itemCount,
                  itemsPerPage: res.data.meta.itemsPerPage,
                  totalItems: res.data.meta.totalItems,
                  totalPages: res.data.meta.totalPages,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          }
        }
      }
    );
  };

  handleStatusChange = (data) => {
    this.setState({ exportDataFromSearch: data })
    let payload = this.state.payload;
    let searchData = this.state.exportDataFromSearch
    this.setState(
      {
        isFetching: true,
        listItems: [],
        currentPage: 1,
      },
      () => { }
    );
    let tempval = data;
    var stat = tempval.toString();
    console.log("---------------status---------", stat);
    this.setState(
      {
        status: stat,
        currentPage: 1,
      },
      () => {
        if (tempval.length == 0) {
          if (this.state.moment_type != 0) {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&page=1&limit=${this.state.itemsPerPage}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                  itemCount: res.data.meta.itemCount,
                  itemsPerPage: res.data.meta.itemsPerPage,
                  totalItems: res.data.meta.totalItems,
                  totalPages: res.data.meta.totalPages,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&limit=${this.state.itemsPerPage}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                  itemCount: res.data.meta.itemCount,
                  itemsPerPage: res.data.meta.itemsPerPage,
                  totalItems: res.data.meta.totalItems,
                  totalPages: res.data.meta.totalPages,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          }
        } else {
          if (this.state.moment_type != 0) {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${data.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&transporter_lr_no=${data.transporter_lr_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&route_id=${data.route_id}&consignor_id=${data.consignor_id}&consignee_id=${data.consignee_id}&page=1&limit=${this.state.itemsPerPage}&invoice_reference_no=${data.invoice_reference_no}&from_order_created_on=${data.from_order_created_on}&to_order_created_on=${data.to_order_created_on}&lr_no=${data.lr_no}&product_id=${data.product_id}&product_category_id=${data.product_category_id}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                  itemCount: res.data.meta.itemCount,
                  itemsPerPage: res.data.meta.itemsPerPage,
                  totalItems: res.data.meta.totalItems,
                  totalPages: res.data.meta.totalPages,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${data.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&transporter_lr_no=${data.transporter_lr_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&route_id=${data.route_id}&consignor_id=${data.consignor_id}&consignee_id=${data.consignee_id}&page=1&limit=${this.state.itemsPerPage}&invoice_reference_no=${data.invoice_reference_no}&from_order_created_on=${data.from_order_created_on}&to_order_created_on=${data.to_order_created_on}&lr_no=${data.lr_no}&product_id=${data.product_id}&product_category_id=${data.product_category_id}`,
              payload,
            })
              .then((res) => {
                this.setState({
                  isFetching: false,
                  listItems: res.data.data,
                  itemCount: res.data.meta.itemCount,
                  itemsPerPage: res.data.meta.itemsPerPage,
                  totalItems: res.data.meta.totalItems,
                  totalPages: res.data.meta.totalPages,
                });
              })
              .catch((err) => {
                console.log("err", err);
              });
          }
        }
      }
    );
  };

  // scroll listener function
  handleScroll = () => {
    let divInnerHeight = document.getElementsByClassName("style");
    let scrollLimit = 59;
    scrollLimit = scrollLimit + 675 * (this.state.page - 1);
    console.log(scrollLimit, divInnerHeight[0].scrollTop);
    if (
      Math.ceil(
        divInnerHeight[0].scrollTop > scrollLimit || this.state.isFetching
      )
    ) {
      this.setState({ isFetching: true }, () => {
        this.incrementPage();
      });
    }
  };

  // new page increment
  incrementPage = () => {
    if (!this.state.isFetching) return;
    this.fetchMoreListItems();
  };

  fetchMoreListItems = () => {
    this.fetchData();
    this.setState({ isFetching: false }, () => this.incrementPage());
  };

  // fetchData = async () => {
  //   setTimeout(
  //     async () => {
  //       if (this.props.shipmentData[this.state.page]) {
  //         let dataArray = [
  //           ...this.state.listItems,
  //           ...this.props.shipmentData[this.state.page],
  //         ];
  //         let { page } = this.state;
  //         this.setState({ page: page + 1, listItems: dataArray });
  //       }
  //     },
  //     1000,
  //     this
  //   );
  // };

  handleMetaSearch = (data) => {
    this.state.exportDataFromSearch = data;
    const payload = data;
    this.setState({searchLoading:true})

    this.setState({ currentPage: 1 }, () => {
      //CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&page=1&limit=${this.state.itemsPerPage}`, payload })
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${payload.status}&bl_no=${data.bl_no}&transporter_lr_no=${data.transporter_lr_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&route_id=${data.route_id}&consignor_id=${data.consignor_id}&consignee_id=${data.consignee_id}&page=1&limit=${this.state.itemsPerPage}&invoice_reference_no=${data.invoice_reference_no}&from_order_created_on=${data.from_order_created_on}&to_order_created_on=${data.to_order_created_on}&lr_no=${data.lr_no}&product_id=${data.product_id}&product_category_id=${data.product_category_id}`,
        payload,
      })
        .then((res) => {
          this.setState({
            isFetching: false,
            listItems: res.data.data,
            currentPage: res.data.meta.currentPage,
            itemCount: res.data.meta.itemCount,
            itemsPerPage: res.data.meta.itemsPerPage,
            totalItems: res.data.meta.totalItems,
            totalPages: res.data.meta.totalPages,
            searchLoading:false
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    });
  };

  handleChange = (e) => {
    console.log(e);
    this.setState({ searchValue: e.target.value });
    let data = e.target.value;
    const payload = data;
    //CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&page=1&limit=${this.state.itemsPerPage}`, payload })
    /* CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&page=${this.state.currentPage}&limit=${this.state.itemsPerPage}`, payload })
      .then((res) => {
        this.setState(
          {
            isFetching: false,
            listItems: res.data.data,
            currentPage: res.data.meta.currentPage,
            itemCount: res.data.meta.itemCount,
            itemsPerPage: res.data.meta.itemsPerPage,
            totalItems: res.data.meta.totalItems,
            totalPages: res.data.meta.totalPages,
          },
        );
      })
      .catch((err) => {
        console.log('err', err);
      }); */
  };

  render() {
    const { t } = this.props;
    let itemsInOnePage = [
      {
        key: "1",
        text: "10",
        value: "10",
      },
      {
        key: "2",
        text: "30",
        value: "30",
      },
      {
        key: "3",
        text: "50",
        value: "50",
      },
      {
        key: "4",
        text: "100",
        value: "100",
      },
    ];


    const onShipmentClick = (item) => {
      localStorage.setItem('freightDetail', item?.deliveries?.[0]?.is_freight_details_editable);
    };

    return (
      <React.Fragment>
        <OrdersHeader
          hideImport={
            localStorage.getItem("customerNumber") == 1158 ? true : false
          }
          showOrderFilterTop={true}
          showSearchFalse={false}
          isLoading={this.state.spinnerLoading}
          title={this.props.title}
          LinkName="/add-shipment"
          hideNew={FEATURES.hideShipmentNewBtn}
          handleSearch={this.handleChange}
          // importDataGrid={this.importDataGrid}
          // exportDataGrid={this.exportDataGrid}
          handleStatusChange={this.handleStatusChange}
          handleFilterChange={this.handleFilterChange}
          handleMetaSearch={this.handleMetaSearch}
          handleFilter={this.handleFilter}
          exportHidden={this.props.exportHidden}
          radioToggle={this.props.radioToggle}
          toggleView={this.props.toggleView}
          toggle={this.props.toggle}
          baseURL={this.props.baseURL}
          exporttrueDataGrid={this.externalAPIexcelDownload}
          handleFilterPadding={this.handleFilterPadding}
          filterFromCardView={true}
          externalAPIexcelDownload={this.externalAPIexcelDownload}
          responseReceived={this.state.responseReceived}
          showStatusFilter={true}
          searchLoading={this.state.searchLoading}
          redirectToOrderReports={this.props.redirectToOrderReports}
        />

        <div
          className="animated slideInDown m-2 style"
          style={
            this.state.filterState
              ? {
                width: "98%",
                height: "74vh",
                overflowY: "auto",
                marginBottom: "20px",
                paddingBottom: "100px",
                paddingTop: "25px",
                scrollbarWidth: "thin",
              }
              : {
                width: "98%",
                height: "74vh",
                overflowY: "auto",
                marginBottom: "20px",
                paddingBottom: "25px",
                paddingTop: "25px",
                scrollbarWidth: "thin",
              }
          }
        //style={{ width: "98%", height: "74vh", overflowY: "auto", marginBottom: "20px", paddingBottom: "25px", paddingTop: "25px" }}
        // onScroll={this.handleScroll}
        >
          {this.state.listItems.length > 0 ? (
            this.state.listItems.map((item, index) => {
              return (
                <Segment
                  key={index}
                  size="mini"
                  raised
                  className="ml-3 mr-4 order-card-text"
                >
                  {item.allotment_status ? (
                    <Label
                      as="a"
                      color={
                        item.allotment_status.allotment_text == "Broadcasted"
                          ? "blue"
                          : item.allotment_status.allotment_text ==
                            "Rebid Request"
                            ? "yellow"
                            : item.allotment_status.allotment_text == "Reject"
                              ? "red"
                              : item.allotment_status.allotment_text == "Allocated"
                                ? "orange"
                                : "grey"
                      }
                      ribbon="right"
                    >
                      <Icon name="dot circle" size="mini" />
                      {item.allotment_status.allotment_text}
                    </Label>
                  ) : (
                    <Label as="a" ribbon="right" color="green">
                      <Icon name="dot circle" size="mini" />
                      {t("list_view.create") || "Create"}
                    </Label>
                  )}
                  <Link
                    target="_blank"
                    onClick={() => { onShipmentClick(item) }}
                    to={{
                      pathname: "/shipment-details",
                      state: { item, index },
                      search: `?shipmentId=${item.shipment.vendor_shipment_id}&orderId=${item.vendor_order_id}`,
                    }}
                  >
                    <Grid columns={1} className="m-1">
                      <Grid.Row textAlign="center">
                        <Grid.Column
                          width={3}
                          className="ml-3"
                          style={{ marginTop: "-15px" }}
                        >
                          <Grid columns="3">
                            <Grid.Row className="pb-0 pt-0 order-label">
                              <Grid.Column>
                                <Label
                                  as="a"
                                  color="pink"
                                  ribbon
                                  style={{ float: "left", marginTop: "-15px" }}
                                >
                                  {t("list_view.order_no") || "Order No"} :{" "}
                                  {item.order_reference_no}
                                </Label>
                                <label className="mt-3 text-nowrap">
                                  {item.shipment.movement_type == "Import" ||
                                    item.shipment.movement_type == "Importar"
                                    ? t("table_view.estimated_on")
                                    : t("table_view.required_on")}
                                </label>
                                <label className="order-date-bold text-nowrap">
                                {moment.parseZone(item.shipment.required_on).format("HH:mm") == "00:00" ?
                                  moment.parseZone
                                      (item.shipment.required_on)
                                      .format(DATE_FORMATS.DATE_DDMMYYYY) : 
                                  moment.parseZone
                                      (item.shipment.required_on)
                                      .format(DATE_FORMATS.DD_MM_YYYY_hh_mm_a)}
                                </label>
                                {item.business_unit &&
                                <label className="w3-text-gray p-bolder w3-small">
                                  {item.business_unit}
                                </label>}
                               
                                {item?.booking_number ? (
                                  <label>
                                    <span className="p-bold-600 text-nowrap">
                                      {t("list_view.booking_number") ||
                                        "Booking Number"}
                                    </span>
                                    <br />
                                    <span className="w3-text-gray mt-3 labelName text-nowrap">
                                      {item.booking_number}
                                    </span>
                                  </label>
                                ) : null}
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </Grid.Column>
                        <Grid.Column width={5}>
                          <RouteManager
                            routeId={item.shipment.route_id}
                            km={item.shipment.budgeted_kms}
                            movement={item.shipment.movement_type}
                            order_details = {item}
                          />
                        </Grid.Column>
                        <Grid.Column width={2}>
                          {item.allotment_status &&
                            item.allotment_status.allotment_code == "BRDCST" ? (
                            <div className="w3-text-blue">
                              <span className="w3-xlarge p-bolder">
                                {item.broadcast
                                  ? item.broadcast.broadcast_replies
                                  : "NA"}
                              </span>
                              <br />
                              <small>{t("list_view.reply") || "Reply"}</small>
                            </div>
                          ) : null}
                        </Grid.Column>
                        <Grid.Column width={2}>
                          {item.allotment_status &&
                            item.allotment_status.allotment_code == "BRDCST" ? (
                            <div className="w3-text-red">
                              <span className="w3-xlarge p-bolder">
                                {item.broadcast
                                  ? item.broadcast.broadcast_count
                                  : "NA"}
                              </span>
                              <br />
                              <small>
                                {t("list_view.broadcast") || "Broadcast"}
                              </small>
                            </div>
                          ) : null}
                        </Grid.Column>
                        <Grid.Column
                          width={3}
                          textAlign="right"
                          className="mt-2"
                        >
                          {item.load_type_id ? (
                            <LoadTyperender loadid={item.load_type_id} />
                          ) : (
                            <>
                              <div>
                                <span
                                  className="sumo_truck_quantity"
                                  style={{
                                    width: "55px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                ></span>
                                <img
                                  src="assets/svg/sumo_truck.svg"
                                  alt="sumo_truck"
                                  width="60%"
                                />
                              </div>
                              <label className="order-load-type">
                                {t("list_view.load_type") || "Load Type"} :
                                &nbsp;
                                <span className="order-load-type-bold">
                                  {"NA"}
                                </span>
                              </label>
                            </>
                          )}
                        </Grid.Column>
                      </Grid.Row>
                      {item.shipment.movement_type == "Import" ||
                        item.shipment.movement_type == "Importar" ? (
                        <Grid.Row className="mr-0 ml-0 p-2 footer-text">
                          {/* <BLNumbers data={item.vendor_order_id} /> */}
                          <span className="ml-3">
                            {" "}
                            {t("list_view.bl_no") || "BL No."} :{" "}
                          </span>{" "}
                          <span className="ml-2">
                            {" "}
                            {item.bl_numbers != ""
                              ? item.bl_numbers
                              : "NA"}{" "}
                          </span>
                        </Grid.Row>
                      ) : null}

                      {/* <Grid.Row style={{borderTop: "1px solid", width:"100%"}} className="p-0 pb-0">
                        <BLNumbers data={item.vendor_order_id}/>
                      </Grid.Row> */}
                    </Grid>
                  </Link>
                </Segment>
              );
            })
          ) : this.state.listItems.length > 0 &&
            this.state.isFetching == false ? (
              <LoadingPlaceholder />
          ) : (
            <>
              {this.state.listItems.length == 0 &&
                this.state.isFetching == false ? (
                <div>No Record(s) Found</div>
              ) : (
                <LoadingPlaceholder />
              )}
            </>
          )}
        </div>

        {this.state.loadingPagination ? (
          <div className="life-cycle w3-white p-2 mt-9">
            <div class="col-3">
              <div class="snippet" data-title=".dot-carousel">
                <div class="stage">
                  <div class="dot-carousel"></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="life-cycle w3-white p-2 mt-9">
              <Pagination
                defaultActivePage={this.state.currentPage}
                firstItem={null}
                lastItem={null}
                onPageChange={this.handlePaginationChange}
                pointing
                secondary
                totalPages={this.state.totalPages}
              />
              {/* <Dropdown
                size="mini"
                className="m-1"
                placeholder="10"
                selection
                defaultValue={"10"}
                onChange={this.handlePagination}
                compact
                options={itemsInOnePage}
              /> */}
            </div>
          </>
        )}
      </React.Fragment>
    );
  }
}

export default translate("shipment")(shipmentGridView);
